<template>
  <div>
    <div class="hs1">
      <img src="../../../assets/img/pagess/mobile/sky101/1.png" alt="">
    </div>
    <div class="h2">
      <img src="../../../assets/img/pagess/mobile/sky101/2.png" alt="">
    </div>
    <div class="h3">
      <img src="../../../assets/img/pagess/mobile/sky101/3.png" alt="">
      <img class="btn" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="">
    </div>
    <div class="h4">
      <img src="../../../assets/img/pagess/mobile/sky101/4.png" alt="">
    </div>
    <div class="h5">
      <img src="../../../assets/img/pagess/mobile/sky101/5.png" alt="">
      <img class="btn" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="">
    </div>
    <div class="h6">
      <img src="../../../assets/img/pagess/mobile/sky101/6.png" alt="">
    </div>
    <div class="h7">
      <img src="../../../assets/img/pagess/mobile/sky101/7.png" alt="">
      <img class="btn" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="">
    </div>
    <div class="h8">
      <img src="../../../assets/img/pagess/mobile/sky101/8.png" alt="">
    </div>
    <div class="h9">
      <img src="../../../assets/img/pagess/mobile/sky101/9.png" alt="">
      <img class="btn" src="../../../assets/img/pagess/mobile/sky101/btns.gif" alt="">
    </div>
    <div class="h10">
      <img src="../../../assets/img/pagess/mobile/sky101/10.png" alt="">
    </div>
    <div class="h11">
      <!-- <img class="img1" src="../../../assets/img/pagess/mobile/sky101/heng.png" alt=""> -->
      <div class="img2">
        <img src="../../../assets/img/pagess/mobile/sky101/btn.gif" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
* {
  font-size: 0;
}
img {
  width: 100%;
  height: 100%;
}
.h3 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0;
    left: 0.8rem;
  }
}
.h5 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0.9rem;
    left: 0.8rem;
  }
}
.h7 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 1.3rem;
    left: 0.8rem;
  }
}
.h9 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    bottom: 1rem;
    left: 0.8rem;
  }
}
.h11 {
  position: fixed;
  bottom: 0;
  width: 7.5rem;
  height: 1.62rem;
  background: url(../../../assets/img/pagess/mobile/sky101/heng.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  .img2 {
    padding-top: 0.19rem;
    padding-right: 0.12rem;
    width: 2.61rem;
    height: 0.78rem;
  }
}
</style> 


// WEBPACK FOOTER //
// src/pages/pagess/mobile/gdd101.vue